import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Activity, BarChart3, Calendar, History, Target, LogOut, User } from 'lucide-react';

const Navigation = ({ user, signOut }) => {
  const location = useLocation();
  const [userName, setUserName] = useState('');

  useEffect(() => {
    // Get user name from localStorage or default to email
    const savedProfile = localStorage.getItem('userProfile');
    if (savedProfile) {
      const profile = JSON.parse(savedProfile);
      setUserName(profile.preferredName || profile.name || '');
    }
    
    // If no saved name, use email username
    if (!userName && user?.attributes?.email) {
      const emailName = user.attributes.email.split('@')[0];
      setUserName(emailName);
    }
  }, [user, userName]);

  const navItems = [
    { path: '/', label: 'Dashboard', icon: BarChart3 },
    { path: '/health', label: 'Health Data', icon: Activity },
    { path: '/planning', label: 'Plan Generator', icon: Target },
    { path: '/workout', label: 'Today\'s Workout', icon: Calendar },
    { path: '/history', label: 'History', icon: History },
    { path: '/account', label: 'Account', icon: User },
  ];

  return (
    <nav className="bg-slate-800 border-b border-slate-700 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="text-xl font-bold text-blue-400 hover:text-blue-300 transition-colors">
              Fitness Planner
            </Link>
            <div className="hidden md:flex space-x-6">
              {navItems.map(({ path, label, icon: Icon }) => (
                <Link
                  key={path}
                  to={path}
                  className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    location.pathname === path
                      ? 'bg-blue-600 text-white'
                      : 'text-slate-300 hover:text-white hover:bg-slate-700'
                  }`}
                >
                  <Icon size={16} />
                  <span>{label}</span>
                </Link>
              ))}
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-slate-300">
              Welcome, {userName || user?.attributes?.email?.split('@')[0] || 'User'}
            </span>
            <button
              onClick={signOut}
              className="flex items-center space-x-2 px-3 py-2 text-sm text-slate-300 hover:text-white hover:bg-slate-700 rounded-md transition-colors"
            >
              <LogOut size={16} />
              <span>Sign Out</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
